import { takeLatest, put, select, take, call } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import get from 'lodash/get';
import omit from 'lodash/omit';

import { SIGN_UP_TYPES } from './constants';
import { selectAuthStatus } from '../selectors';
import {
  selectProfileEditable,
  selectShowMfaAfterMobileAppPopup,
} from '../../profiles/selectors';
import {
  PERSONAL_INFO,
  HEALTHBOARD,
  COMMUNITIES,
} from '../../../constants/routes';
import { selectSignupProcessFormData } from './selectors';
import * as signup from './signup-req';
import * as editUser from '../../profiles/edit-user';
import * as createPatient from '../../profiles/create-patient';
import * as profileEditable from '../../profiles/profile-editable-req';
import * as usernameAvailability from './username-availability-req';
import { INVITATION_TYPES } from '../../../constants/props';
import deepTrim from '../../../utils/converters/deepTrim';
import parseJSONSafely from '../../../utils/parseJSONSafely';
import checkIsAppStoreLinksAvailability from '../../../utils/checkIsAppStoreLinksAvailability';
import {
  showMobileAppPopup,
  showMfaNoticePopup as showMfaNoticePopupAction,
  consts as popupConsts,
} from '../../ui/popup';
import { decodeQueryParams } from '../../../components/Auth/utils/decodeQueryParams';

function* handleSignUpProceed({ payload }) {
  const username = get(payload, 'username');

  yield put(
    usernameAvailability.actions.send({
      username: decodeQueryParams(username),
    }),
  );
  yield take(usernameAvailability.consts.SUCCEED);

  yield browserHistory.push(`/${PERSONAL_INFO}`);
}

const EDIT_USER_INVITATION_TYPES = [
  INVITATION_TYPES.FAMILY_MEMBER,
  INVITATION_TYPES.COMMUNITY_MEMBER,
];

function* handleConfirmSignUp({ payload }) {
  const signupFormData = yield select(selectSignupProcessFormData);
  const editableData = yield select(selectProfileEditable);
  const { invitationType } = yield select(selectAuthStatus);

  const personalInfoFormData = editableData ? payload : omit(payload, ['ssn']);
  const dataToSend = deepTrim({ ...signupFormData, ...personalInfoFormData });

  if (EDIT_USER_INVITATION_TYPES.includes(invitationType)) {
    yield put(createPatient.actions.send(dataToSend));
    yield take(createPatient.consts.SUCCEED);

    if (invitationType === INVITATION_TYPES.FAMILY_MEMBER) {
      yield browserHistory.push(`/${HEALTHBOARD}`);
    }

    if (invitationType === INVITATION_TYPES.COMMUNITY_MEMBER) {
      const targetCommunityId = parseJSONSafely(
        window.storage.getItem('communityId'),
      );
      yield browserHistory.push(`/${COMMUNITIES}/${targetCommunityId}`);
    }

    const { hasAtLeastOneStoreLink } = yield call(
      checkIsAppStoreLinksAvailability,
    );

    if (hasAtLeastOneStoreLink) {
      yield put(showMobileAppPopup());
    }

    return;
  }

  yield put(editUser.actions.send(dataToSend));
  yield take(editUser.consts.SUCCEED);
  yield browserHistory.push(`/${HEALTHBOARD}`);
}

function* handleSignupSucceed({ payload }) {
  const id = get(payload, 'authentication.user.id');
  yield put(profileEditable.actions.send({ userId: id }));
}

export function* showMfaNoticePopup() {
  const showMfaAfterMobileAppPopup = yield select(
    selectShowMfaAfterMobileAppPopup,
  );
  if (showMfaAfterMobileAppPopup) {
    yield put(showMfaNoticePopupAction());
  }
}

export default function*() {
  yield takeLatest(SIGN_UP_TYPES.PROCEED, handleSignUpProceed);
  yield takeLatest(SIGN_UP_TYPES.CONFIRM, handleConfirmSignUp);
  yield takeLatest(signup.consts.SUCCEED, handleSignupSucceed);
  yield takeLatest(popupConsts.HIDE, showMfaNoticePopup);
}



// WEBPACK FOOTER //
// ./src/redux/auth/signup/signup-saga.js